// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__22STj","text":"SelectPayment_text__2ioTW","title":"SelectPayment_title__2Yr5H","btn":"SelectPayment_btn__3JKt0"};